import styled from 'styled-components';

import Accordion from '../../../../../../../../../components/Accordion';

// Folded, the panel keeps the same gap under the form field as the shared accordion opens with.
const Panel = styled(Accordion)`
  margin-top: 15px;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
  padding-bottom: 8px;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 44px;
`;

const LogoPreview = styled.img`
  height: 44px;
  max-width: 88px;
  margin-right: 8px;
  object-fit: contain;
`;

export {
  Panel,
  Row,
  LogoRow,
  LogoPreview,
};
